import React from 'react';

import { PopoverProps } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

import { getFieldError, hasFieldError } from 'src/utils/finalForm';

import type { DatetimeFieldProps } from './interface';

const POPOVER_PROPS: Partial<PopoverProps> = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
};

export const DateTimeField: React.FC<DatetimeFieldProps> = ({
  input,
  meta,
  fullWidth,
  ...rest
}) => {
  const { name, value, onChange } = input;

  const handleChange = React.useCallback(
    (date: DateTime | null) => {
      onChange(date ? date.toISO() : date);
    },
    [onChange],
  );

  const error = hasFieldError(meta);
  const helperText = getFieldError(meta);

  const props = {
    name,
    error,
    helperText,
    value: value ? DateTime.fromISO(value) : null,
    onChange: handleChange,
    slotProps: { textField: { fullWidth }, popover: POPOVER_PROPS },
    ...rest,
  };

  return <DateTimePicker {...props} />;
};
